import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import * as icons from 'mdi-material-ui';

const FiltersButton = ({ onClick }) => {
    return (
        <IconButton
            sx={{
                marginLeft: '10px',
                '&:hover': { background: 'inherit', color: 'primary.main' },
            }}
            size="small"
            onClick={onClick}
            disableRipple
        >
            <icons.FilterMenu />
        </IconButton>
    );
};

FiltersButton.propTypes = { onClick: PropTypes.func.isRequired };

export default FiltersButton;
